// HelperFunctions/categoryFilters.js

const norm = (v) => (v ?? "").toString().trim().toUpperCase();

/** Turn status into a Set of codes: FP, MA, GI/PROT, EQ, NAP */
export const getStatusSet = (raw) => {
  if (raw == null) return new Set();

  const parts = Array.isArray(raw) ? raw : [raw];

  const tokens = parts
    .flatMap((x) => String(x).split(/[,;|]/))
    .map((s) => norm(s))
    .filter(Boolean);

  // Normalise variants
  const out = new Set();
  for (const t of tokens) {
    if (t === "GI" || t === "GI/PROT" || t === "GI/PROTECTION")
      out.add("GI/PROT");
    else if (t === "ER" || t === "EQUITY" || t === "EQUITY RELEASE")
      out.add("ER");
    else if (t === "FP") out.add("FP");
    else if (t === "MA") out.add("MA");
    else if (t === "NAP") out.add("NAP");
    // keep unknown tokens if you ever need them:
    // else out.add(t);
  }

  return out;
};

/**
 * Checkbox label -> rule.
 * rule.type:
 *  - "ANY": adviser has ANY of required statuses
 *  - "ALL": adviser has ALL required statuses (used for FP+MA)
 */
export const CAT_RULES = {
  "Financial Planners": { type: "ANY", required: ["FP"] },
  "Mortgage Advisers": { type: "ANY", required: ["MA"] },
  "Qualified in both Financial Planners & Mortgage Advisers": {
    type: "ALL",
    required: ["FP", "MA"],
  },
  "GI/Protection Advisers": { type: "ANY", required: ["GI/PROT"] },
  "Equity Release": { type: "ANY", required: ["ER"] },
  NAP: { type: "ANY", required: ["NAP"] },
};

/**
 * Filter advisers by selected categories.
 * - If none selected -> ALL advisers
 * - Otherwise -> adviser matches ANY selected category
 */
export const filterAdvisersByCats = (advisers = [], selectedCats = []) => {
  if (!selectedCats?.length) return advisers;

  const activeRules = selectedCats.map((c) => CAT_RULES[c]).filter(Boolean);

  if (!activeRules.length) return advisers;

  return (advisers || []).filter((a) => {
    const statusSet = getStatusSet(a.status ?? a.adviserStatus);

    // match ANY selected checkbox
    return activeRules.some((rule) => {
      const req = rule.required || [];
      if (rule.type === "ALL") return req.every((r) => statusSet.has(r));
      return req.some((r) => statusSet.has(r));
    });
  });
};
